// extracted by mini-css-extract-plugin
export default {"bell":"notificationbell_bell__3uvie","bell__icon":"notificationbell_bell__icon__wyXxK","bell__badge":"notificationbell_bell__badge__OX6p1"};